import { Decoder, array } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { programResourcesResourceDecoder } from '../../ProgramResourceList/ProgramResourcesStore/Decoders';
import { CrossProgramResourcesResource } from './Types';

export const crossProgramResourcesResourceDecoder: Decoder<CrossProgramResourcesResource> =
  resourceDecoder(array(programResourcesResourceDecoder));
